import { render } from "./About.vue?vue&type=template&id=75d41482&bindings={\"toots\":\"data\",\"isLoading\":\"data\",\"getMyMastodonStatus\":\"options\",\"tootDate\":\"options\",\"hasBeenCreatedToday\":\"options\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script